import Lottie from 'lottie-react';

export { Lottie };
